// Same-origin Shopify HTML; no separate product catalogue, prices or cart.
const assetBase=new URL('.',import.meta.url);
const en=document.documentElement.lang.startsWith('en');
const copy=en?{product:'Product',close:'Close product',cart:'View basket',loading:'Loading product…',error:'We could not load this product. Check your connection and try again.',retry:'Try again',page:'Open product page',added:'Added to your basket.'}:{product:'Producto',close:'Cerrar producto',cart:'Ver cesta',loading:'Cargando producto…',error:'No se ha podido cargar el producto. Revisa la conexión y vuelve a intentarlo.',retry:'Reintentar',page:'Abrir ficha del producto',added:'Añadido a tu cesta.'};

// Both native storefronts retain their full Shopify HTML; only mobile folds it.
const descriptionDesktop=matchMedia('(min-width:750px)');
function prepareProductDescriptions(root){
 if(!root||root.querySelector('cx-qr'))return;
 const selector='.product-details > .group-block > .group-block-content > rte-formatter, .pdp-description > .native-description';
 for(const description of root.querySelectorAll(selector)){
  if(!description.textContent.trim())continue;
  const disclosure=document.createElement('details'),summary=document.createElement('summary');
  disclosure.className='cx-web-sheet__description';disclosure.dataset.webProductDescription='';
  disclosure.open=descriptionDesktop.matches;
  summary.textContent=en?'Description & details':'Descripción y detalles';
  description.before(disclosure);disclosure.append(summary,description);
  // Existing headings define the reading sections. Preserve every original node.
  if([...description.children].filter(child=>/^H[2-4]$/.test(child.tagName)).length>1){
   const original=[...description.childNodes];let section=document.createElement('div');
   section.className='cx-web-description__intro';description.classList.add('cx-web-description__sections');
   description.append(section);
   for(const child of original){
    if(/^H[2-4]$/.test(child.nodeName)){
     section=document.createElement('div');section.className='cx-web-description__section';description.append(section);
    }
    section.append(child);
   }
  }
  // One full-width row below image and purchase, also retaining mobile reading order.
  const grid=disclosure.closest('.product-information__grid');
  if(grid)grid.append(disclosure);
 }
}
if(!document.querySelector('cx-qr')){
 prepareProductDescriptions(document.querySelector('#MainContent'));
 descriptionDesktop.addEventListener('change',()=>{
  for(const disclosure of document.querySelectorAll('[data-web-product-description]'))disclosure.open=descriptionDesktop.matches;
 });
}

function productURL(value){
 if(typeof value!=='string'||!value.trim())return null;
 let url;try{url=new URL(value,location.href);}catch{return null;}
 if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9-]+\/)?products\/[a-z0-9-]+\/?$/.test(url.pathname)||url.searchParams.has('view'))return null;
 const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 url.hash='';return url;
}

if(!document.querySelector('cx-qr')&&typeof HTMLDialogElement!=='undefined'&&HTMLDialogElement.prototype.showModal){
 const node=(tag,cls,text)=>{const n=document.createElement(tag);n.className=cls;if(text)n.textContent=text;return n;};
 const sheet=node('dialog','cx-web-sheet'),header=node('div','cx-web-sheet__header'),label=node('span','cx-web-sheet__label',copy.product),close=node('button','cx-web-sheet__close','×'),cart=node('button','cx-web-sheet__cart',copy.cart),content=node('div','cx-web-sheet__content'),feedback=node('p','cx-web-sheet__feedback');
 sheet.dataset.webProductSheet='';sheet.setAttribute('aria-label',copy.product);close.type=cart.type='button';close.setAttribute('aria-label',copy.close);close.dataset.webSheetClose='';cart.dataset.webSheetCart='';feedback.setAttribute('role','status');feedback.setAttribute('aria-live','polite');
 header.append(label,cart,close);sheet.append(header,content,feedback);document.body.append(sheet);
 const owner=String(Date.now())+Math.random(),loadedScripts=new Set([...document.scripts].filter(s=>s.src).map(s=>s.src));
 let source=null,savedScroll=0,savedBody='',savedRestoration='',savedTitle='',requestId=0,controller=null,dispose=null,historyClosing=false,afterClose=null,pendingOpen=null;
 const owns=state=>state?.cxWebProductSheet?.owner===owner;
 function cleanup(){dispose?.();dispose=null;for(const dialog of content.querySelectorAll('dialog[open]'))dialog.close();for(const video of content.querySelectorAll('video'))video.pause();content.replaceChildren();feedback.textContent='';}
 function finishClose(){
  if(!sheet.open)return;
  controller?.abort();requestId++;
  cleanup();sheet.close();document.documentElement.classList.remove('cx-web-sheet-open');document.body.style.cssText=savedBody;history.scrollRestoration=savedRestoration;document.title=savedTitle;
  window.scrollTo({top:savedScroll,behavior:'instant'});
  if(source?.isConnected){source.focus({preventScroll:true});if(document.activeElement!==source){const card=source.closest('product-card');if(card){card.setAttribute('tabindex','-1');card.focus({preventScroll:true});}}}
 }
 function finishHistoryClose(){
  historyClosing=false;
  const next=afterClose,reopen=pendingOpen;afterClose=null;pendingOpen=null;
  if(reopen)open(reopen.url,reopen.trigger);else next?.();
 }
 function requestClose(next=null){
  if(historyClosing){if(next){afterClose=next;pendingOpen=null;}return;}
  afterClose=next;pendingOpen=null;
  // Release the modal now; retain a new opening until the asynchronous Back
  // completes, so that its popstate cannot dismiss the newly opened product.
  historyClosing=owns(history.state);finishClose();
  if(historyClosing)history.back();else finishHistoryClose();
 }
 function setVariant(value,path){
  if(!sheet.open||historyClosing||!owns(history.state))return;
  const url=path?productURL(path):new URL(location.href);if(!url)return;
  if(value)url.searchParams.set('variant',String(value));else url.searchParams.delete('variant');
  history.replaceState(history.state,'',url);
 }
 function ageVerified(){if(document.documentElement.classList.contains('crysalidas-age-verified'))return true;try{return sessionStorage.getItem('crysalidas_age_verified_session')==='1';}catch{return false;}}
 async function dependencies(doc,main){
  // Load only native theme modules referenced by the returned product; no inline or app scripts.
  const pending=[];
  for(const script of main.querySelectorAll('script[src]')){
   const url=new URL(script.getAttribute('src'),location.href);
   if(url.origin!==assetBase.origin||!url.pathname.startsWith(assetBase.pathname)||!url.pathname.endsWith('.js')||loadedScripts.has(url.href))continue;
   loadedScripts.add(url.href);const native=document.createElement('script');native.src=url.href;native.type=script.type||'module';
   pending.push(new Promise((resolve,reject)=>{native.onload=resolve;native.onerror=()=>{loadedScripts.delete(url.href);reject(Error('Product module unavailable'));};document.head.append(native);}));
  }
  for(const link of doc.querySelectorAll('link[rel=stylesheet]')){
   const url=new URL(link.getAttribute('href'),location.href);
   if(url.origin!==assetBase.origin||!url.pathname.includes('/cdn/shop/t/')||[...document.querySelectorAll('link[rel=stylesheet]')].some(existing=>existing.href===url.href))continue;
   const style=document.createElement('link');style.rel='stylesheet';style.href=url.href;
   pending.push(new Promise((resolve,reject)=>{style.onload=resolve;style.onerror=()=>{style.remove();reject(Error('Product style unavailable'));};document.head.append(style);}));
  }
  await Promise.all(pending);
 }

 function refineMainProduct(){
  const details=content.querySelector('.product-details'),heading=details?.querySelector('h1');
  if(!details||!heading)return;
  // Reuse the actual Shopify provenance and description; no generated product copy.
  const provenance=details.querySelector('.crysalidas-product-details-context__provenance');
  if(provenance){
   const context=provenance.parentElement,title=heading.closest('.text-block')||heading;
   title.before(provenance);
   if(!context.textContent.trim())context.remove();
  }

 }
 async function showProduct(doc,id){
  const main=doc.querySelector('#MainContent'),isCBD=document.body.classList.contains('cx-cbd');
  if(!main?.querySelector(isCBD?'.pdp':'[data-product-grid-content]')||doc.body.classList.contains('cx-cbd')!==isCBD)throw Error('Product outside this storefront');
  const cbdModule=isCBD?await import('./cx-cbd-product.js?v=20261021-variants'):null;
  await dependencies(doc,main);if(id!==requestId||!sheet.open)return;
  main.querySelectorAll('script:not([type="application/json"]),sticky-add-to-cart,.cx-breadcrumbs').forEach(n=>n.remove());
  content.replaceChildren(...main.childNodes);content.scrollTop=0;
  label.textContent=isCBD?copy.product:'CRYSALIDAS';
  if(!isCBD)refineMainProduct();
  prepareProductDescriptions(content);
  sheet.setAttribute('aria-label',content.querySelector('h1')?.textContent||copy.product);document.title=doc.title||savedTitle;content.removeAttribute('aria-busy');
  // Shopify's existing components upgrade on insertion. CBD reuses its direct-page form module.
  if(cbdModule)dispose=cbdModule.mountCBDProduct(content,{onVariant:setVariant,onAdded:async()=>{
   if(sheet.open&&id===requestId)feedback.textContent=copy.added;
   // Counts are refreshed from the same native session, never incremented speculatively.
   try{const prefix=window.Shopify?.routes?.root||'/',response=await fetch(prefix+'cart.js',{credentials:'same-origin',cache:'no-store'});if(!response.ok)return;const basket=await response.json();if(!Number.isSafeInteger(basket.item_count))return;
    for(const badge of document.querySelectorAll('[data-cbd-cart-count]')){badge.textContent=String(basket.item_count);badge.hidden=!basket.item_count;}
    for(const link of document.querySelectorAll('[data-cbd-cart-link]'))link.setAttribute('aria-label','Cesta, '+basket.item_count+' artículos');
   }catch{}
  }});
 }
 async function showResponse(doc,id){
  const gate=doc.querySelector('[data-crysalidas-age-gate]');
  if(gate&&!ageVerified()){
   const card=gate.querySelector('.crysalidas-age-gate__card');if(!card)throw Error('Missing age gate');
   content.replaceChildren(card);content.removeAttribute('aria-busy');
   card.querySelector('[data-crysalidas-age-accept]').onclick=async()=>{
    try{sessionStorage.setItem('crysalidas_age_verified_session','1');}catch{}
    document.documentElement.classList.add('crysalidas-age-verified');
    try{await showProduct(doc,id);if(id===requestId&&sheet.open)close.focus({preventScroll:true});}catch{if(id===requestId&&sheet.open)showError(new URL(location.href));}
   };
   card.querySelector('[data-crysalidas-age-exit],[data-cbd-age-decline]')?.addEventListener('click',event=>{event.preventDefault();requestClose();});return;
  }
  await showProduct(doc,id);
 }
 function showError(url){
  cleanup();content.removeAttribute('aria-busy');const status=node('p','cx-web-sheet__status',copy.error),retry=node('button','cx-web-sheet__retry',copy.retry),link=node('a','cx-web-sheet__fallback',copy.page);
  status.setAttribute('role','alert');retry.type='button';retry.onclick=()=>load(url);link.href=url.href;link.dataset.webSheetFallback='';content.append(status,retry,link);
 }
 async function load(url){
  controller?.abort();controller=new AbortController();const active=controller,id=++requestId;cleanup();sheet.setAttribute('aria-label',copy.product);
  const status=node('p','cx-web-sheet__status',copy.loading);status.setAttribute('role','status');content.append(status);content.setAttribute('aria-busy','true');
  const timer=setTimeout(()=>active.abort(),15000);
  try{
   const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'},signal:active.signal});
   if(!response.ok||new URL(response.url).origin!==location.origin)throw Error('Product unavailable');
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');if(id!==requestId||!sheet.open)return;await showResponse(doc,id);
  }catch{if(id===requestId&&sheet.open)showError(url);}
  finally{clearTimeout(timer);}
 }
 function open(url,trigger,{fromHistory=false}={}){
  if(historyClosing){pendingOpen={url,trigger};afterClose=null;return;}
  if(!sheet.open){
   source=trigger||source;savedScroll=window.scrollY;savedBody=document.body.style.cssText;savedRestoration=history.scrollRestoration;savedTitle=document.title;history.scrollRestoration='manual';
   document.documentElement.classList.add('cx-web-sheet-open');Object.assign(document.body.style,{position:'fixed',top:-savedScroll+'px',width:'100%'});
   sheet.dataset.state='entering';sheet.showModal();close.focus({preventScroll:true});void sheet.offsetHeight;requestAnimationFrame(()=>{if(sheet.open&&!historyClosing)sheet.dataset.state='open';});
  }
  if(!fromHistory){const state={...(history.state||{}),cxWebProductSheet:{owner}};if(owns(history.state))history.replaceState(state,'',url);else history.pushState(state,'',url);}
  load(url);
 }
 window.addEventListener('click',event=>{
  if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||document.documentElement.classList.contains('crysalidas-age-lock'))return;
  const target=event.target;if(!(target instanceof Element)||target.closest('cx-qr,[data-web-sheet-fallback]'))return;
  const link=target.closest('a[href]'),card=target.closest('product-card,product-card-link'),choose=target.closest('.quick-add__button--choose');
  if(link&&(link.target&&link.target!=='_self'||link.hasAttribute('download')))return;
  if(!choose&&target.closest('button,input,select,label,textarea,[role=button]')&&!link)return;
  const url=productURL(card?.productPageUrl||link?.href);if(!url)return;
  event.preventDefault();event.stopImmediatePropagation();open(url,link||choose||card?.querySelector('[ref="productCardLink"],a[href]')||card);
 },true);
 sheet.addEventListener('shopify:product:select',event=>{
  const id=requestId;
  event.promise?.then(({detail})=>{if(id===requestId&&content.contains(event.target))setVariant(detail?.resource?.id,detail?.newProduct?.url);}).catch(()=>{});
 });
 sheet.addEventListener('shopify:cart:lines-update',event=>{const id=requestId;event.promise?.then(({detail})=>{if(!detail?.didError&&sheet.open&&id===requestId)feedback.textContent=copy.added;}).catch(()=>{});});
 close.onclick=()=>requestClose();cart.onclick=()=>requestClose(()=>{const drawer=document.querySelector('theme-drawer#cart-drawer');if(drawer?.open)drawer.open();else location.assign((window.Shopify?.routes?.root||'/')+'cart');});
 sheet.addEventListener('cancel',event=>{event.preventDefault();requestClose();});
 let outsideDown=false;sheet.addEventListener('pointerdown',event=>outsideDown=event.target===sheet);
 sheet.addEventListener('click',event=>{if(outsideDown&&event.target===sheet){const r=sheet.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)requestClose();}outsideDown=false;});
 window.addEventListener('popstate',event=>{if(historyClosing){finishHistoryClose();return;}if(owns(event.state)){const url=productURL(location.href);if(url)open(url,null,{fromHistory:true});}else finishClose();});
 window.addEventListener('pagehide',()=>{historyClosing=false;pendingOpen=null;afterClose=null;finishClose();});
 window.addEventListener('pageshow',event=>{if(event.persisted&&owns(history.state)){const url=productURL(location.href);if(url)open(url,null,{fromHistory:true});}});
}
